import { Container } from "@Components/container/container.component"
import { CookieConsent } from "@Components/cookie-consent/cookie-consent.component"
import { LinkButton } from "@Components/link-button/link-button"
import { useEffect } from "react"

// import SyntaxHighlighter from 'react-syntax-highlighter';
// import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';

export const Grid = () => {
	useEffect(() => {
		const el = document.getElementById("grid-page")

		if (el) {
			setTimeout(() => {
				el.classList.add("loaded")
			}, 1)
		}
	}, [])

	return (
		<div className="homePage" id="grid-page">
			<div id="background-grid">
				<div className="grid-wrapper">
					<div className="grid">
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
						<span />
					</div>
				</div>
			</div>

			<CookieConsent />

			<Container
				containerSpacing="pt-1 pb-1"
				containerWidth="wide"
				containerID="hello-hero"
				containerBackground="pearl">
				<div className="hero-content-wrapper">
					<div className="headlines">
						<div className="text-wrapper">
							<div>
								<h1>Composable Compliance</h1>
							</div>
							<h2>Web3 framework for compliant smart contracts </h2>
							<div className="button-wrapper">
								<LinkButton type={"primary"}>Check video</LinkButton>
								<LinkButton type={"primary"}>Check video</LinkButton>
							</div>
						</div>
						<div className="image-wrapper">
							<img src={require("@Assets/hero-illustration.svg")} />
						</div>
					</div>
					<div className="usps">
						<ul>
							<li>
								<div className="circle">
									<i className="material-icons">refresh</i>
								</div>
								<div className="text">
									<h4>Composable</h4>
									<p>web3 native primitives to enable smart contracts</p>
								</div>
							</li>
							<li>
								<div className="circle">
									<i className="material-icons">refresh</i>
								</div>
								<div className="text">
									<h4>Privacy-preserving</h4>
									<p>no PII moves to avoid data duplication</p>
								</div>
							</li>
							<li>
								<div className="circle">
									<i className="material-icons">refresh</i>
								</div>
								<div className="text">
									<h4>Trusted</h4>
									<p>Ecosystem of trusted partners</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</Container>

			<Container
				containerID="logos"
				containerSpacing="pt-2 pb-1"
				containerWidth="wide">
				<div className="wrapper">
					<div className="availabe">
						<span>available on</span>
						<ul className="">
							<li>
								<svg
									width="62"
									height="63"
									viewBox="0 0 62 63"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_3924_13457)">
										<path
											d="M24.4737 55.9737C34.3872 55.9737 42.4211 47.9398 42.4211 38.0263C42.4211 28.1128 34.3872 20.0789 24.4737 20.0789C14.5602 20.0789 6.52632 28.1128 6.52632 38.0263C6.52632 47.9398 14.5602 55.9737 24.4737 55.9737ZM24.4737 62.5C10.9577 62.5 0 51.5423 0 38.0263C0 24.5103 10.9577 13.5526 24.4737 13.5526C37.9897 13.5526 48.9474 24.5103 48.9474 38.0263C48.9474 51.5423 37.9897 62.5 24.4737 62.5Z"
											fill="#FBCC5C"
										/>
										<path
											d="M37.5264 42.9211C47.4399 42.9211 55.4738 34.8872 55.4738 24.9737C55.4738 15.0602 47.4399 7.02632 37.5264 7.02632C27.6129 7.02632 19.5791 15.0602 19.5791 24.9737C19.5791 34.8872 27.6129 42.9211 37.5264 42.9211ZM37.5264 49.4474C24.0104 49.4474 13.0527 38.4897 13.0527 24.9737C13.0527 11.4577 24.0104 0.5 37.5264 0.5C51.0424 0.5 62.0001 11.4577 62.0001 24.9737C62.0001 38.4897 51.0424 49.4474 37.5264 49.4474Z"
											fill="#35D07F"
										/>
										<path
											d="M38.3357 49.4474C40.0325 47.3916 41.2464 44.9834 41.8925 42.3924C44.4769 41.7463 46.8852 40.5324 48.9475 38.8356C48.8561 41.8311 48.21 44.781 47.0418 47.5482C44.2812 48.7099 41.3313 49.356 38.3357 49.4474ZM20.1077 20.6076C17.5233 21.2537 15.1151 22.4676 13.0527 24.1644C13.1441 21.1688 13.7902 18.2189 14.9584 15.4583C17.7191 14.2966 20.6755 13.6505 23.6645 13.5526C21.9677 15.6084 20.7538 18.0166 20.1077 20.6076Z"
											fill="#5EA33B"
										/>
									</g>
									<defs>
										<clipPath id="clip0_3924_13457">
											<rect
												width="62"
												height="62"
												fill="white"
												transform="translate(0 0.5)"
											/>
										</clipPath>
									</defs>
								</svg>
							</li>

							<li>
								<svg
									width="67"
									height="65"
									viewBox="0 0 67 65"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_3924_13465)">
										<path
											d="M9.20078 1.42188H58.7008C62.4133 1.42188 65.507 4.46875 65.507 8.125V56.875C65.507 60.5312 62.4133 63.5781 58.7008 63.5781H9.20078C5.48828 63.5781 2.39453 60.5312 2.39453 56.875V8.125C2.39453 4.46875 5.48828 1.42188 9.20078 1.42188Z"
											fill="#2D2D2D"
										/>
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M9.20075 2.77601C6.24762 2.77601 3.76946 5.21662 3.76946 8.12501V56.875C3.76946 59.7834 6.24762 62.224 9.20075 62.224H58.7007C61.6539 62.224 64.132 59.7834 64.132 56.875V8.12501C64.132 5.21662 61.6539 2.77601 58.7007 2.77601H9.20075ZM1.01953 8.12501C1.01953 3.72089 4.72887 0.067749 9.20075 0.067749H58.7007C63.1726 0.067749 66.882 3.72089 66.882 8.12501V56.875C66.882 61.2791 63.1726 64.9323 58.7007 64.9323H9.20075C4.72887 64.9323 1.01953 61.2791 1.01953 56.875V8.12501Z"
											fill="white"
										/>
										<path
											d="M33.9508 48.75C34.5695 48.75 34.982 48.5469 35.3945 48.3437C35.807 47.9375 36.0133 47.5313 36.0133 46.9219L36.4258 44.4844C34.7758 44.8906 33.1258 44.8906 31.4758 44.4844L31.8883 46.9219C31.8883 47.5313 32.0945 47.9375 32.507 48.3437C32.9195 48.5469 33.332 48.75 33.9508 48.75ZM48.182 48.3437H52.1008V26.2031C52.1008 23.1562 50.657 21.125 48.182 20.3125V48.3437ZM15.8008 48.3437H19.7195V20.3125C17.2445 21.125 15.8008 23.1562 15.8008 26.2031V48.3437V48.3437ZM36.4258 44.4844C38.9008 43.875 40.757 42.0469 41.1695 38.7969L43.6445 20.1094C40.757 20.7187 39.3133 22.9531 38.6945 26.4062L36.4258 44.4844ZM31.4758 44.4844L29.207 26.4062C28.7945 22.9531 27.1445 20.7187 24.4633 20.1094L26.9383 38.7969C27.3508 42.0469 29.0008 43.875 31.4758 44.4844ZM48.182 20.3125V18.6875C48.182 17.0625 47.357 16.25 46.1195 16.25C44.882 16.25 44.057 17.0625 43.8508 18.4844L43.6445 20.1094C45.0883 19.9062 46.7383 19.9062 48.182 20.3125ZM19.7195 20.3125C20.5445 20.1094 21.5758 19.9063 22.4008 19.9063C23.0195 19.9063 23.6383 19.9062 24.4633 20.1094L24.257 18.4844C23.8445 16.8594 23.0195 16.25 21.782 16.25C20.5445 16.25 19.7195 17.0625 19.7195 18.6875V20.3125Z"
											fill="#2D2D2D"
										/>
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M19.2519 15.9677C19.9206 15.2151 20.8435 14.8959 21.782 14.8959C22.64 14.8959 23.5086 15.1134 24.2343 15.7387C24.9344 16.3421 25.3465 17.193 25.5909 18.156L25.611 18.2353L25.7171 19.0706C28.5623 20.1298 30.1608 22.8095 30.572 26.2439C30.5722 26.2453 30.5724 26.2467 30.5725 26.248L32.7185 43.3473C33.5406 43.4641 34.3609 43.4641 35.183 43.3473L37.3343 26.2054L37.3405 26.1709C37.6696 24.3339 38.2395 22.6855 39.2125 21.3873C40.023 20.3058 41.0797 19.5134 42.3929 19.0532L42.4894 18.2928C42.6223 17.3764 42.975 16.5177 43.6262 15.8765C44.2965 15.2163 45.1741 14.8959 46.1195 14.8959C47.058 14.8959 47.9809 15.2151 48.6496 15.9677C49.2972 16.6966 49.557 17.6642 49.557 18.6875V19.4045C50.6377 19.9226 51.5438 20.6794 52.2135 21.6688C53.0638 22.9248 53.4757 24.4697 53.4757 26.2031V49.6979H46.807V21.4123C46.1808 21.3284 45.5207 21.3118 44.867 21.3485L42.5338 38.9648C42.5337 38.9661 42.5335 38.9675 42.5333 38.9688C42.2986 40.8132 41.6407 42.3442 40.611 43.5167C39.7895 44.4522 38.771 45.1139 37.643 45.5285L37.3863 47.0454C37.373 47.4641 37.291 47.8689 37.115 48.259C36.9244 48.6813 36.6542 49.0182 36.3667 49.3013L36.209 49.4567L35.9773 49.5708C35.5527 49.7801 34.8957 50.1041 33.9507 50.1041C33.0058 50.1041 32.3488 49.7801 31.9242 49.5708L31.6925 49.4567L31.5347 49.3013C31.2473 49.0182 30.9771 48.6813 30.7865 48.259C30.6105 47.8689 30.5285 47.4641 30.5152 47.0454L30.2581 45.5261C29.1332 45.106 28.1475 44.4336 27.3655 43.4837C26.394 42.3036 25.8047 40.7787 25.5744 38.9686C25.5742 38.9673 25.5741 38.9661 25.5739 38.9648L23.2317 21.2805C22.9625 21.2611 22.6975 21.2604 22.4007 21.2604C22.0263 21.2604 21.5692 21.3164 21.0945 21.402V49.6979H15.8007V48.3438H14.4258V26.2031C14.4258 24.4697 14.8377 22.9248 15.688 21.6688C16.3577 20.6794 17.2638 19.9226 18.3445 19.4045V18.6875C18.3445 17.6642 18.6043 16.6966 19.2519 15.9677ZM21.0946 18.6573C21.0996 18.0774 21.2485 17.8332 21.3215 17.7511C21.3747 17.6912 21.483 17.6041 21.782 17.6041C22.1615 17.6041 22.3242 17.6913 22.4235 17.7769C22.5306 17.8693 22.6981 18.0785 22.8497 18.5546C22.7003 18.5521 22.5581 18.5521 22.4221 18.5521L22.4007 18.5521C21.9823 18.5521 21.5351 18.5937 21.0946 18.6573ZM18.3445 22.7092C18.2094 22.8536 18.0866 23.0077 17.976 23.1711C17.4857 23.8955 17.1757 24.8897 17.1757 26.2031V46.9896H18.3445V22.7092ZM26.1697 22.5246L28.3026 38.6289C28.4852 40.0672 28.9269 41.08 29.5016 41.778C29.5927 41.8887 29.6888 41.9936 29.7902 42.0926L27.8414 26.5645C27.6182 24.6961 27.0253 23.3756 26.1697 22.5246ZM33.1456 46.1149L33.2632 46.8098V46.9219C33.2632 47.0686 33.2864 47.1303 33.2994 47.159C33.3074 47.1768 33.3216 47.2037 33.3504 47.2423C33.5968 47.3555 33.74 47.3959 33.9507 47.3959C34.1615 47.3959 34.3047 47.3555 34.5511 47.2423C34.5799 47.2037 34.5941 47.1768 34.6021 47.159C34.6151 47.1303 34.6383 47.0686 34.6383 46.9219V46.8098L34.7559 46.1149C34.2192 46.1526 33.6823 46.1526 33.1456 46.1149ZM38.1017 42.1696C38.2542 42.0388 38.3974 41.8973 38.5311 41.7451C39.1507 41.0394 39.627 40.0327 39.8051 38.6289L39.8061 38.6217L41.9533 22.4095C41.7614 22.5849 41.5862 22.7804 41.425 22.9956C40.8039 23.8243 40.3446 25.0088 40.0546 26.6078L38.1017 42.1696ZM45.2277 18.6248C45.7469 18.6141 46.2776 18.6317 46.807 18.6852C46.8066 18.0852 46.6542 17.8345 46.58 17.7511C46.5268 17.6912 46.4185 17.6041 46.1195 17.6041C45.8273 17.6041 45.6738 17.6899 45.5706 17.7915C45.465 17.8956 45.3289 18.1025 45.2466 18.4826L45.2277 18.6248ZM49.557 22.7092V46.9896H50.7258V26.2031C50.7258 24.8897 50.4158 23.8955 49.9255 23.1711C49.8149 23.0077 49.6921 22.8536 49.557 22.7092Z"
											fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_3924_13465">
											<rect
												width="66"
												height="65"
												fill="white"
												transform="translate(0.951172)"
											/>
										</clipPath>
									</defs>
								</svg>
							</li>

							<li>
								<svg
									width="66"
									height="65"
									viewBox="0 0 66 65"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_3924_13461)">
										<path
											d="M32.9756 65C50.9248 65 65.4756 50.4493 65.4756 32.5C65.4756 14.5507 50.9248 0 32.9756 0C15.0263 0 0.475586 14.5507 0.475586 32.5C0.475586 50.4493 15.0263 65 32.9756 65Z"
											fill="#FF0420"
										/>
										<path
											d="M23.4982 41.132C21.5612 41.132 19.9752 40.677 18.7402 39.767C17.5182 38.844 16.9072 37.518 16.9072 35.815C16.9072 35.451 16.9462 35.022 17.0242 34.502C17.2322 33.332 17.5312 31.928 17.9212 30.277C19.0262 25.805 21.8862 23.569 26.4882 23.569C27.7362 23.569 28.8672 23.777 29.8552 24.206C30.8432 24.609 31.6232 25.233 32.1952 26.065C32.7672 26.884 33.0532 27.859 33.0532 28.99C33.0532 29.328 33.0142 29.757 32.9362 30.277C32.6892 31.72 32.4032 33.137 32.0522 34.502C31.4802 36.725 30.5052 38.402 29.1012 39.507C27.7102 40.599 25.8382 41.132 23.4982 41.132ZM23.8492 37.622C24.7592 37.622 25.5262 37.349 26.1632 36.816C26.8132 36.283 27.2812 35.464 27.5542 34.346C27.9312 32.812 28.2172 31.486 28.4122 30.342C28.4772 30.004 28.5162 29.653 28.5162 29.289C28.5162 27.807 27.7492 27.066 26.2022 27.066C25.2922 27.066 24.5122 27.339 23.8622 27.872C23.2252 28.405 22.7702 29.224 22.4972 30.342C22.1982 31.434 21.9122 32.76 21.6132 34.346C21.5482 34.671 21.5092 35.009 21.5092 35.373C21.4962 36.881 22.2892 37.622 23.8492 37.622Z"
											fill="white"
										/>
										<path
											d="M34.1844 40.898C34.0024 40.898 33.8724 40.846 33.7684 40.729C33.6904 40.599 33.6644 40.456 33.6904 40.287L37.0574 24.427C37.0834 24.245 37.1744 24.102 37.3304 23.985C37.4734 23.868 37.6294 23.816 37.7984 23.816H44.2854C46.0924 23.816 47.5354 24.193 48.6274 24.934C49.7324 25.688 50.2914 26.767 50.2914 28.184C50.2914 28.587 50.2394 29.016 50.1484 29.458C49.7454 31.33 48.9264 32.708 47.6784 33.605C46.4564 34.502 44.7794 34.944 42.6474 34.944H39.3584L38.2404 40.287C38.2014 40.469 38.1234 40.612 37.9674 40.729C37.8244 40.846 37.6684 40.898 37.4994 40.898H34.1844ZM42.8164 31.577C43.5054 31.577 44.0904 31.395 44.5974 31.018C45.1174 30.641 45.4554 30.108 45.6244 29.406C45.6764 29.133 45.7024 28.886 45.7024 28.678C45.7024 28.21 45.5594 27.846 45.2864 27.599C45.0134 27.339 44.5324 27.209 43.8694 27.209H40.9444L40.0214 31.577H42.8164V31.577Z"
											fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_3924_13461">
											<rect
												width="65"
												height="65"
												fill="white"
												transform="translate(0.475586)"
											/>
										</clipPath>
									</defs>
								</svg>
							</li>

							<li>
								<svg
									width="83"
									height="66"
									viewBox="0 0 83 66"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M13.4792 49.7968C13.9866 49.2896 14.6748 49.0049 15.3923 49.0049H81.5861C82.792 49.0049 83.3955 50.4629 82.5425 51.3152L69.4628 64.3846C68.9554 64.8918 68.2671 65.1766 67.5497 65.1766H1.35587C0.150019 65.1766 -0.453529 63.7184 0.399449 62.8661L13.4792 49.7968Z"
										fill="url(#paint0_linear_3924_13444)"
									/>
									<path
										d="M13.4792 0.968814C13.9866 0.461719 14.6748 0.17688 15.3923 0.17688H81.5861C82.792 0.17688 83.3955 1.63501 82.5425 2.48739L69.4628 15.5567C68.9554 16.0637 68.2671 16.3486 67.5497 16.3486H1.35587C0.150019 16.3486 -0.453529 14.8906 0.399449 14.0383L13.4792 0.968814Z"
										fill="url(#paint1_linear_3924_13444)"
									/>
									<path
										d="M69.4628 25.2238C68.9554 24.7168 68.2671 24.4319 67.5497 24.4319H1.35587C0.150019 24.4319 -0.453529 25.8901 0.399449 26.7422L13.4792 39.8118C13.9866 40.3188 14.6748 40.6037 15.3923 40.6037H81.5861C82.792 40.6037 83.3955 39.1455 82.5425 38.2931L69.4628 25.2238Z"
										fill="url(#paint2_linear_3924_13444)"
									/>
									<defs>
										<linearGradient
											id="paint0_linear_3924_13444"
											x1="56.0737"
											y1="-17.6509"
											x2="10.2619"
											y2="70.0972"
											gradientUnits="userSpaceOnUse">
											<stop stopColor="#00FFA3" />
											<stop offset="1" stopColor="#DC1FFF" />
										</linearGradient>
										<linearGradient
											id="paint1_linear_3924_13444"
											x1="56.0737"
											y1="-17.6525"
											x2="10.2619"
											y2="70.0956"
											gradientUnits="userSpaceOnUse">
											<stop stopColor="#00FFA3" />
											<stop offset="1" stopColor="#DC1FFF" />
										</linearGradient>
										<linearGradient
											id="paint2_linear_3924_13444"
											x1="56.0737"
											y1="-17.6552"
											x2="10.2619"
											y2="70.0929"
											gradientUnits="userSpaceOnUse">
											<stop stopColor="#00FFA3" />
											<stop offset="1" stopColor="#DC1FFF" />
										</linearGradient>
									</defs>
								</svg>
							</li>
						</ul>
					</div>

					<div className="soon">
						<span>soon</span>
						<ul className="">
							<li>
								<svg
									width="62"
									height="63"
									viewBox="0 0 62 63"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_3924_13457)">
										<path
											d="M24.4737 55.9737C34.3872 55.9737 42.4211 47.9398 42.4211 38.0263C42.4211 28.1128 34.3872 20.0789 24.4737 20.0789C14.5602 20.0789 6.52632 28.1128 6.52632 38.0263C6.52632 47.9398 14.5602 55.9737 24.4737 55.9737ZM24.4737 62.5C10.9577 62.5 0 51.5423 0 38.0263C0 24.5103 10.9577 13.5526 24.4737 13.5526C37.9897 13.5526 48.9474 24.5103 48.9474 38.0263C48.9474 51.5423 37.9897 62.5 24.4737 62.5Z"
											fill="#FBCC5C"
										/>
										<path
											d="M37.5264 42.9211C47.4399 42.9211 55.4738 34.8872 55.4738 24.9737C55.4738 15.0602 47.4399 7.02632 37.5264 7.02632C27.6129 7.02632 19.5791 15.0602 19.5791 24.9737C19.5791 34.8872 27.6129 42.9211 37.5264 42.9211ZM37.5264 49.4474C24.0104 49.4474 13.0527 38.4897 13.0527 24.9737C13.0527 11.4577 24.0104 0.5 37.5264 0.5C51.0424 0.5 62.0001 11.4577 62.0001 24.9737C62.0001 38.4897 51.0424 49.4474 37.5264 49.4474Z"
											fill="#35D07F"
										/>
										<path
											d="M38.3357 49.4474C40.0325 47.3916 41.2464 44.9834 41.8925 42.3924C44.4769 41.7463 46.8852 40.5324 48.9475 38.8356C48.8561 41.8311 48.21 44.781 47.0418 47.5482C44.2812 48.7099 41.3313 49.356 38.3357 49.4474ZM20.1077 20.6076C17.5233 21.2537 15.1151 22.4676 13.0527 24.1644C13.1441 21.1688 13.7902 18.2189 14.9584 15.4583C17.7191 14.2966 20.6755 13.6505 23.6645 13.5526C21.9677 15.6084 20.7538 18.0166 20.1077 20.6076Z"
											fill="#5EA33B"
										/>
									</g>
									<defs>
										<clipPath id="clip0_3924_13457">
											<rect
												width="62"
												height="62"
												fill="white"
												transform="translate(0 0.5)"
											/>
										</clipPath>
									</defs>
								</svg>
							</li>

							<li>
								<svg
									width="67"
									height="65"
									viewBox="0 0 67 65"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_3924_13465)">
										<path
											d="M9.20078 1.42188H58.7008C62.4133 1.42188 65.507 4.46875 65.507 8.125V56.875C65.507 60.5312 62.4133 63.5781 58.7008 63.5781H9.20078C5.48828 63.5781 2.39453 60.5312 2.39453 56.875V8.125C2.39453 4.46875 5.48828 1.42188 9.20078 1.42188Z"
											fill="#2D2D2D"
										/>
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M9.20075 2.77601C6.24762 2.77601 3.76946 5.21662 3.76946 8.12501V56.875C3.76946 59.7834 6.24762 62.224 9.20075 62.224H58.7007C61.6539 62.224 64.132 59.7834 64.132 56.875V8.12501C64.132 5.21662 61.6539 2.77601 58.7007 2.77601H9.20075ZM1.01953 8.12501C1.01953 3.72089 4.72887 0.067749 9.20075 0.067749H58.7007C63.1726 0.067749 66.882 3.72089 66.882 8.12501V56.875C66.882 61.2791 63.1726 64.9323 58.7007 64.9323H9.20075C4.72887 64.9323 1.01953 61.2791 1.01953 56.875V8.12501Z"
											fill="white"
										/>
										<path
											d="M33.9508 48.75C34.5695 48.75 34.982 48.5469 35.3945 48.3437C35.807 47.9375 36.0133 47.5313 36.0133 46.9219L36.4258 44.4844C34.7758 44.8906 33.1258 44.8906 31.4758 44.4844L31.8883 46.9219C31.8883 47.5313 32.0945 47.9375 32.507 48.3437C32.9195 48.5469 33.332 48.75 33.9508 48.75ZM48.182 48.3437H52.1008V26.2031C52.1008 23.1562 50.657 21.125 48.182 20.3125V48.3437ZM15.8008 48.3437H19.7195V20.3125C17.2445 21.125 15.8008 23.1562 15.8008 26.2031V48.3437V48.3437ZM36.4258 44.4844C38.9008 43.875 40.757 42.0469 41.1695 38.7969L43.6445 20.1094C40.757 20.7187 39.3133 22.9531 38.6945 26.4062L36.4258 44.4844ZM31.4758 44.4844L29.207 26.4062C28.7945 22.9531 27.1445 20.7187 24.4633 20.1094L26.9383 38.7969C27.3508 42.0469 29.0008 43.875 31.4758 44.4844ZM48.182 20.3125V18.6875C48.182 17.0625 47.357 16.25 46.1195 16.25C44.882 16.25 44.057 17.0625 43.8508 18.4844L43.6445 20.1094C45.0883 19.9062 46.7383 19.9062 48.182 20.3125ZM19.7195 20.3125C20.5445 20.1094 21.5758 19.9063 22.4008 19.9063C23.0195 19.9063 23.6383 19.9062 24.4633 20.1094L24.257 18.4844C23.8445 16.8594 23.0195 16.25 21.782 16.25C20.5445 16.25 19.7195 17.0625 19.7195 18.6875V20.3125Z"
											fill="#2D2D2D"
										/>
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M19.2519 15.9677C19.9206 15.2151 20.8435 14.8959 21.782 14.8959C22.64 14.8959 23.5086 15.1134 24.2343 15.7387C24.9344 16.3421 25.3465 17.193 25.5909 18.156L25.611 18.2353L25.7171 19.0706C28.5623 20.1298 30.1608 22.8095 30.572 26.2439C30.5722 26.2453 30.5724 26.2467 30.5725 26.248L32.7185 43.3473C33.5406 43.4641 34.3609 43.4641 35.183 43.3473L37.3343 26.2054L37.3405 26.1709C37.6696 24.3339 38.2395 22.6855 39.2125 21.3873C40.023 20.3058 41.0797 19.5134 42.3929 19.0532L42.4894 18.2928C42.6223 17.3764 42.975 16.5177 43.6262 15.8765C44.2965 15.2163 45.1741 14.8959 46.1195 14.8959C47.058 14.8959 47.9809 15.2151 48.6496 15.9677C49.2972 16.6966 49.557 17.6642 49.557 18.6875V19.4045C50.6377 19.9226 51.5438 20.6794 52.2135 21.6688C53.0638 22.9248 53.4757 24.4697 53.4757 26.2031V49.6979H46.807V21.4123C46.1808 21.3284 45.5207 21.3118 44.867 21.3485L42.5338 38.9648C42.5337 38.9661 42.5335 38.9675 42.5333 38.9688C42.2986 40.8132 41.6407 42.3442 40.611 43.5167C39.7895 44.4522 38.771 45.1139 37.643 45.5285L37.3863 47.0454C37.373 47.4641 37.291 47.8689 37.115 48.259C36.9244 48.6813 36.6542 49.0182 36.3667 49.3013L36.209 49.4567L35.9773 49.5708C35.5527 49.7801 34.8957 50.1041 33.9507 50.1041C33.0058 50.1041 32.3488 49.7801 31.9242 49.5708L31.6925 49.4567L31.5347 49.3013C31.2473 49.0182 30.9771 48.6813 30.7865 48.259C30.6105 47.8689 30.5285 47.4641 30.5152 47.0454L30.2581 45.5261C29.1332 45.106 28.1475 44.4336 27.3655 43.4837C26.394 42.3036 25.8047 40.7787 25.5744 38.9686C25.5742 38.9673 25.5741 38.9661 25.5739 38.9648L23.2317 21.2805C22.9625 21.2611 22.6975 21.2604 22.4007 21.2604C22.0263 21.2604 21.5692 21.3164 21.0945 21.402V49.6979H15.8007V48.3438H14.4258V26.2031C14.4258 24.4697 14.8377 22.9248 15.688 21.6688C16.3577 20.6794 17.2638 19.9226 18.3445 19.4045V18.6875C18.3445 17.6642 18.6043 16.6966 19.2519 15.9677ZM21.0946 18.6573C21.0996 18.0774 21.2485 17.8332 21.3215 17.7511C21.3747 17.6912 21.483 17.6041 21.782 17.6041C22.1615 17.6041 22.3242 17.6913 22.4235 17.7769C22.5306 17.8693 22.6981 18.0785 22.8497 18.5546C22.7003 18.5521 22.5581 18.5521 22.4221 18.5521L22.4007 18.5521C21.9823 18.5521 21.5351 18.5937 21.0946 18.6573ZM18.3445 22.7092C18.2094 22.8536 18.0866 23.0077 17.976 23.1711C17.4857 23.8955 17.1757 24.8897 17.1757 26.2031V46.9896H18.3445V22.7092ZM26.1697 22.5246L28.3026 38.6289C28.4852 40.0672 28.9269 41.08 29.5016 41.778C29.5927 41.8887 29.6888 41.9936 29.7902 42.0926L27.8414 26.5645C27.6182 24.6961 27.0253 23.3756 26.1697 22.5246ZM33.1456 46.1149L33.2632 46.8098V46.9219C33.2632 47.0686 33.2864 47.1303 33.2994 47.159C33.3074 47.1768 33.3216 47.2037 33.3504 47.2423C33.5968 47.3555 33.74 47.3959 33.9507 47.3959C34.1615 47.3959 34.3047 47.3555 34.5511 47.2423C34.5799 47.2037 34.5941 47.1768 34.6021 47.159C34.6151 47.1303 34.6383 47.0686 34.6383 46.9219V46.8098L34.7559 46.1149C34.2192 46.1526 33.6823 46.1526 33.1456 46.1149ZM38.1017 42.1696C38.2542 42.0388 38.3974 41.8973 38.5311 41.7451C39.1507 41.0394 39.627 40.0327 39.8051 38.6289L39.8061 38.6217L41.9533 22.4095C41.7614 22.5849 41.5862 22.7804 41.425 22.9956C40.8039 23.8243 40.3446 25.0088 40.0546 26.6078L38.1017 42.1696ZM45.2277 18.6248C45.7469 18.6141 46.2776 18.6317 46.807 18.6852C46.8066 18.0852 46.6542 17.8345 46.58 17.7511C46.5268 17.6912 46.4185 17.6041 46.1195 17.6041C45.8273 17.6041 45.6738 17.6899 45.5706 17.7915C45.465 17.8956 45.3289 18.1025 45.2466 18.4826L45.2277 18.6248ZM49.557 22.7092V46.9896H50.7258V26.2031C50.7258 24.8897 50.4158 23.8955 49.9255 23.1711C49.8149 23.0077 49.6921 22.8536 49.557 22.7092Z"
											fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_3924_13465">
											<rect
												width="66"
												height="65"
												fill="white"
												transform="translate(0.951172)"
											/>
										</clipPath>
									</defs>
								</svg>
							</li>

							<li>
								<svg
									width="66"
									height="65"
									viewBox="0 0 66 65"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_3924_13461)">
										<path
											d="M32.9756 65C50.9248 65 65.4756 50.4493 65.4756 32.5C65.4756 14.5507 50.9248 0 32.9756 0C15.0263 0 0.475586 14.5507 0.475586 32.5C0.475586 50.4493 15.0263 65 32.9756 65Z"
											fill="#FF0420"
										/>
										<path
											d="M23.4982 41.132C21.5612 41.132 19.9752 40.677 18.7402 39.767C17.5182 38.844 16.9072 37.518 16.9072 35.815C16.9072 35.451 16.9462 35.022 17.0242 34.502C17.2322 33.332 17.5312 31.928 17.9212 30.277C19.0262 25.805 21.8862 23.569 26.4882 23.569C27.7362 23.569 28.8672 23.777 29.8552 24.206C30.8432 24.609 31.6232 25.233 32.1952 26.065C32.7672 26.884 33.0532 27.859 33.0532 28.99C33.0532 29.328 33.0142 29.757 32.9362 30.277C32.6892 31.72 32.4032 33.137 32.0522 34.502C31.4802 36.725 30.5052 38.402 29.1012 39.507C27.7102 40.599 25.8382 41.132 23.4982 41.132ZM23.8492 37.622C24.7592 37.622 25.5262 37.349 26.1632 36.816C26.8132 36.283 27.2812 35.464 27.5542 34.346C27.9312 32.812 28.2172 31.486 28.4122 30.342C28.4772 30.004 28.5162 29.653 28.5162 29.289C28.5162 27.807 27.7492 27.066 26.2022 27.066C25.2922 27.066 24.5122 27.339 23.8622 27.872C23.2252 28.405 22.7702 29.224 22.4972 30.342C22.1982 31.434 21.9122 32.76 21.6132 34.346C21.5482 34.671 21.5092 35.009 21.5092 35.373C21.4962 36.881 22.2892 37.622 23.8492 37.622Z"
											fill="white"
										/>
										<path
											d="M34.1844 40.898C34.0024 40.898 33.8724 40.846 33.7684 40.729C33.6904 40.599 33.6644 40.456 33.6904 40.287L37.0574 24.427C37.0834 24.245 37.1744 24.102 37.3304 23.985C37.4734 23.868 37.6294 23.816 37.7984 23.816H44.2854C46.0924 23.816 47.5354 24.193 48.6274 24.934C49.7324 25.688 50.2914 26.767 50.2914 28.184C50.2914 28.587 50.2394 29.016 50.1484 29.458C49.7454 31.33 48.9264 32.708 47.6784 33.605C46.4564 34.502 44.7794 34.944 42.6474 34.944H39.3584L38.2404 40.287C38.2014 40.469 38.1234 40.612 37.9674 40.729C37.8244 40.846 37.6684 40.898 37.4994 40.898H34.1844ZM42.8164 31.577C43.5054 31.577 44.0904 31.395 44.5974 31.018C45.1174 30.641 45.4554 30.108 45.6244 29.406C45.6764 29.133 45.7024 28.886 45.7024 28.678C45.7024 28.21 45.5594 27.846 45.2864 27.599C45.0134 27.339 44.5324 27.209 43.8694 27.209H40.9444L40.0214 31.577H42.8164V31.577Z"
											fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_3924_13461">
											<rect
												width="65"
												height="65"
												fill="white"
												transform="translate(0.475586)"
											/>
										</clipPath>
									</defs>
								</svg>
							</li>

							<li>
								<svg
									width="83"
									height="66"
									viewBox="0 0 83 66"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M13.4792 49.7968C13.9866 49.2896 14.6748 49.0049 15.3923 49.0049H81.5861C82.792 49.0049 83.3955 50.4629 82.5425 51.3152L69.4628 64.3846C68.9554 64.8918 68.2671 65.1766 67.5497 65.1766H1.35587C0.150019 65.1766 -0.453529 63.7184 0.399449 62.8661L13.4792 49.7968Z"
										fill="url(#paint0_linear_3924_13444)"
									/>
									<path
										d="M13.4792 0.968814C13.9866 0.461719 14.6748 0.17688 15.3923 0.17688H81.5861C82.792 0.17688 83.3955 1.63501 82.5425 2.48739L69.4628 15.5567C68.9554 16.0637 68.2671 16.3486 67.5497 16.3486H1.35587C0.150019 16.3486 -0.453529 14.8906 0.399449 14.0383L13.4792 0.968814Z"
										fill="url(#paint1_linear_3924_13444)"
									/>
									<path
										d="M69.4628 25.2238C68.9554 24.7168 68.2671 24.4319 67.5497 24.4319H1.35587C0.150019 24.4319 -0.453529 25.8901 0.399449 26.7422L13.4792 39.8118C13.9866 40.3188 14.6748 40.6037 15.3923 40.6037H81.5861C82.792 40.6037 83.3955 39.1455 82.5425 38.2931L69.4628 25.2238Z"
										fill="url(#paint2_linear_3924_13444)"
									/>
									<defs>
										<linearGradient
											id="paint0_linear_3924_13444"
											x1="56.0737"
											y1="-17.6509"
											x2="10.2619"
											y2="70.0972"
											gradientUnits="userSpaceOnUse">
											<stop stopColor="#00FFA3" />
											<stop offset="1" stopColor="#DC1FFF" />
										</linearGradient>
										<linearGradient
											id="paint1_linear_3924_13444"
											x1="56.0737"
											y1="-17.6525"
											x2="10.2619"
											y2="70.0956"
											gradientUnits="userSpaceOnUse">
											<stop stopColor="#00FFA3" />
											<stop offset="1" stopColor="#DC1FFF" />
										</linearGradient>
										<linearGradient
											id="paint2_linear_3924_13444"
											x1="56.0737"
											y1="-17.6552"
											x2="10.2619"
											y2="70.0929"
											gradientUnits="userSpaceOnUse">
											<stop stopColor="#00FFA3" />
											<stop offset="1" stopColor="#DC1FFF" />
										</linearGradient>
									</defs>
								</svg>
							</li>
						</ul>
					</div>
				</div>
			</Container>

			<Container containerSpacing="pt-1 pb-1" containerWidth="narrow">
				<h4 className="narrow">
					KYC NFTs are nontransferable, which unlock novel use cases in web3
					including trusted communities, fair voting and DAO governance, DeFi,
					cryptonative on and off ramps for fiat, artist, team, or founder
					verification, and pseudoanonymous fundraising and investment.
				</h4>
			</Container>

			<Container
				containerID="integration"
				containerSpacing="pb-1"
				containerWidth="wide"
				// containerBackground="pearl"
			>
				<div className="wrapper">
					<div className="code">
						<div>
							<h1 className="headline">Integration</h1>
						</div>
						<h4>by developers for developers</h4>

						<div className="code-wrapper">
							<div className="header">
								<i className="material-icons">code</i>
								<h4>Install code example</h4>
							</div>

							<div className="code-content">
								<ul>
									<li>
										<div className="step">
											<span>1</span>
											<pre>
												<code>yarn add @kycdao/widget</code>
											</pre>
										</div>
									</li>

									<li>
										<div className="step">
											<span>2</span>
											<pre>
												<code>yarn add @kycdao/widget</code>
											</pre>
										</div>
									</li>

									<li>
										<div className="step">
											<span>2</span>
											<pre>
												<code>yarn add @kycdao/widget</code>
											</pre>
										</div>
									</li>
								</ul>
							</div>
						</div>
						<div className="button-wrapper">
							<button id="" className="kyc-button primary ">
								<i className="material-icons nav"> navigate_next </i>
								<span>Check video</span>
								<i className="material-icons arrow"> arrow_forward </i>
							</button>

							<button
								id="check-documentation-button"
								className="kyc-button secondary">
								<i className="material-icons nav"> navigate_next </i>
								<span>Check documentation</span>
								<i className="material-icons arrow"> arrow_forward </i>
							</button>
						</div>
					</div>

					<div className="process">
						<ul>
							<li>
								<div className="step">
									<span>1</span>
									<p>Register as a partner (use the form)</p>
								</div>
							</li>

							<li>
								<div className="step">
									<span>2</span>
									<p>Install kycDAO SDK (via yarn / npm)</p>
								</div>
							</li>

							<li>
								<div className="step">
									<span>3</span>
									<p>Configure your integration (check the docs) </p>
								</div>
							</li>

							<li>
								<div className="step">
									<span>4</span>
									<p>Deploy & Verify</p>
								</div>
							</li>

							<li>
								<div className="step">
									<span>5</span>
									<p>Go Live</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</Container>

			<Container containerSpacing="pt-1 " containerWidth="narrow" />

			<Container
				containerID="the-sdk"
				containerSpacing=""
				containerWidth="wide"
				containerBackground="pearl">
				<div className="wrapper">
					<div className="text-wrapper">
						<div className="headline-wrapper">
							<h1 className="headline">UI SDK in action</h1>
							<h4>
								The embed kycDAO widget to onboard wallet holders as trusted
								members. <br />
							</h4>
						</div>

						<div className="paragraph-wrapper">
							<p>
								<ul>
									<li>5 min to integrate </li>
									<li>website and smart contract gating</li>
									<li>regular updates</li>
								</ul>
							</p>
							<div className="button-wrapper">
								<LinkButton type={"primary"}>Learn more</LinkButton>
							</div>
						</div>
					</div>

					<div className="swiper-part">
						<div className="card-controller">
							<div className="arrows">
								<i className="material-icons">arrow_back</i>
								<i className="material-icons">arrow_forward</i>
							</div>

							<ul>
								<li className="selected">
									<i className="material-icons">chevron_right</i>
									<span>1. Connect Wallet</span>
								</li>

								<li className="">
									<i className="material-icons">chevron_right</i>
									<span>2. Verify account</span>
								</li>

								<li className="">
									<i className="material-icons">chevron_right</i>
									<span>3. Select NFT art</span>
								</li>

								<li className="">
									<i className="material-icons">chevron_right</i>
									<span>4. Mint kycNFT</span>
								</li>
							</ul>
						</div>
						<div className="illustration">
							<img src={require("@Assets/example-cards.svg")} />
						</div>
					</div>
				</div>
			</Container>

			<Container
				containerID="the-nft"
				containerSpacing="pb-1"
				containerWidth="wide">
				<div className="wrapper">
					<div className="text-wrapper">
						<h1 className="headline">kYcnft</h1>
						<h4>
							The web3 primitive to compose compliance. <br />
							kycNFTs represent a valid membership in kycDAO used by dApps,
							smart contracts and services to build trust.
						</h4>
						<p>
							kycNFTs
							<ul>
								<li>Soulbound or non transferable</li>
								<li>Unique / Personalizable / Owned</li>
								<li>Available on multiple chains</li>
								<li>Not contain personal information</li>
							</ul>
						</p>
					</div>
					<div className="illustration">
						<img src={require("@Assets/soulbound-nfts.svg")} />
					</div>
				</div>
			</Container>

			<Container
				containerID="benefits-grid"
				containerSpacing="pb-1"
				containerWidth="normal"
				containerBackground="">
				<div className="title-wrapper">
					<h1 className="headline">Benefit from composing compliance</h1>
				</div>
				<ul>
					<li>
						<div className="image-wrapper">
							{/*<img src={require("@Assets/champ-cup.png")} />*/}
						</div>
						<h4>Compliant smart contracts</h4>
						<p>
							Proofs issued by kycDAO are backed by the compliance processes
							managed by our trusted Issuer network. kycDAO compliance board is
							setting compliance requirements to ensure that all issued proofs
							are equally trusted.
						</p>
					</li>

					<li>
						<div className="image-wrapper">
							{/*<img src={require("@Assets/games.png")} />*/}
						</div>
						<h4>Smart contract gating</h4>
						<p>
							Gate with kycDAO proofs to ensure that all wallets using your
							services and smart contracts meet compliance requirements.
							(Without accessing personal data of the wallet owner)
						</p>
					</li>

					<li>
						<div className="image-wrapper">
							{/*<img src={require("@Assets/games.png")} />*/}
						</div>
						<h4>One-time verification</h4>
						<p>
							kycDAO proofs are the last verification you ever need. They are
							reusable on multiple chains and offer unlimited access to
							compliant services
						</p>
					</li>
				</ul>
			</Container>

			<Container
				containerID="compliance"
				containerSpacing="pb-1"
				containerWidth="wide"
				containerBackground="pearl">
				<div className="wrapper">
					<div className="header">
						<h1 className="headline">Compliance</h1>
						<h4>
							To ensure trust across kycDAO Issuers, verification process,
							information security and regulatory requirements are taken into
							account by the design.
						</h4>
					</div>

					<ul>
						<li>
							<h4>Data</h4>
							<p>
								kycDAO Issuers meet comprehensive data governance requirements.
								Policies and procedures ensure the safety and confidentiality of
								wallet owner data.
							</p>
						</li>

						<li>
							<h4>Regulation</h4>
							<p>
								Compliance requirements will be related to the know your
								customer and anti-money laundering requirements. The objective
								here is to have a clear understanding of the compliance needs of
								our products.
							</p>
						</li>

						<li>
							<h4>Privacy</h4>
							<p>
								kycDAO proofs do not contain identity data, and personal
								information is not shared. Proofs only represent a compliant
								account with an issuer.
							</p>
						</li>
					</ul>
				</div>
			</Container>

			{/*spaceing*/}
			<Container
				containerID=""
				containerSpacing="pt-1"
				containerWidth="wide"
				containerBackground=""
			/>

			<Container
				containerID="usecase-swiper"
				containerSpacing="pb-1"
				containerWidth="wide"
				containerBackground="warm">
				<div className="wrapper">
					<div className="header">
						<div>
							<h1 className="headline">Use cases</h1>
							<h1 className="headline">1 / 7</h1>
						</div>
						<div className="arrows">
							<i className="material-icons">arrow_back</i>
							<i className="material-icons">arrow_forward</i>
						</div>
					</div>
					<h4>
						kycNFTs are the building block of trust for web3, <br />
						openly usable by any project.
					</h4>
				</div>

				<div className="listing">
					<ul>
						<li id="defi">
							<div className="header">
								<div className="image-wrapper">
									<img src={require("@Assets/daos.svg")} />
								</div>
								<div className="title-wrapper">
									<span>1</span>
									<h4>DAOs</h4>
								</div>
							</div>

							<p className="body">
								Shared compliance framework to defragment liquidity.
							</p>

							<div className="footer">
								<p className="examples">dex/lending/yield...</p>
								<div className="button">
									<span>Learn more</span>
									<i className="material-icons">east</i>
								</div>
							</div>
						</li>

						<li id="grants">
							<div className="header">
								<div className="image-wrapper">
									<img src={require("@Assets/grants.svg")} />
								</div>
								<div className="title-wrapper">
									<span>2</span>
									<h4>Grants</h4>
								</div>
							</div>

							<p className="body">Anonymous compliance for grantees.</p>

							<div className="footer">
								<p className="examples">dex/lending/yield...</p>
								<div className="button">
									<span>Learn more</span>
									<i className="material-icons">east</i>
								</div>
							</div>
						</li>

						<li id="communities">
							<div className="header">
								<div className="image-wrapper">
									<img src={require("@Assets/daos.svg")} />
								</div>
								<div className="title-wrapper">
									<span>3</span>
									<h4>Communities</h4>
								</div>
							</div>

							<p className="body">
								Trusted DAO members to avoid regulatory scrutiny
							</p>

							<div className="footer">
								<p className="examples">NFT/DAO/Game/Social...</p>
								<div className="button">
									<span>Learn more</span>
									<i className="material-icons">east</i>
								</div>
							</div>
						</li>

						<li id="tokens">
							<div className="header">
								<div className="image-wrapper">
									<img src={require("@Assets/tokens.svg")} />
								</div>
								<div className="title-wrapper">
									<span>4</span>
									<h4>Assets</h4>
								</div>
							</div>

							<p className="body">Develop with compliance in mind</p>

							<div className="footer">
								<p className="examples">RWA/TradFi/ICO...</p>
								<div className="button">
									<span>Learn more</span>
									<i className="material-icons">east</i>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</Container>

			<Container
				containerID=""
				containerSpacing="pt-1"
				containerWidth="wide"
				containerBackground=""
			/>
		</div>
	)
}
